import React from "react"
import PropTypes from "prop-types"
import "./marketing-bt-welcome-page.scss"
import Button from "../shared/button/text-button"

const MarketingBT = ({ handleButtonClick }) => (
  <div className="marketing-page-container">
    <div className="marketingPage marketing-page--bt">
      <div className="row resize">
        <img
          className="main-image"
          src="images/marketing/BT_dad.jpeg"
          width="1700px"
          alt=""
        />
        <img
          className="phone-image"
          src="images/marketing/BT_dad_crop.jpg"
          width="100%"
          alt=""
        />
        <div className="text-over-image">
          <p>
            Connecting the UK like never before with the best of broadband, TV
            and mobile with brilliant, expert customer service.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="column">
          <img src="images/marketing/BT_halo_girl.jpeg" alt="" />
          <h3>BT Halo</h3>
          <p>
            <strong>Connecting the UK like never before.</strong>
          </p>
          <p>
            Combining the best of 4G, 5G and fibre with game changing
            reliability, speeds and service like you’ve never experienced.
          </p>
          <p>
            Welcome to BT Halo – for the best connection in and out of the home.
          </p>
        </div>
        <div className="column">
          <img src="images/marketing/BT_girl_on_sofa.jpeg" alt="" />
          <h3>Full Fibre Broadband</h3>
          <p>
            <strong>The UK’s biggest Full Fibre provider.</strong>
          </p>
          <p>
            With gigabit speeds piped straight into your home, it doesn’t matter
            how many devices you and your family connect to it: our Full Fibre
            broadband stays reliably fast, day and night.
          </p>
        </div>
        <div className="column">
          <div className="bt-logo">
            <img src="images/marketing/BT_TV_logo.png" alt="" />
          </div>
          <img src="images/marketing/BT_dad2.jpeg" alt="" />
          <h3>BT TV</h3>
          <p>
            <strong>New Flexible TV.</strong>
          </p>
          <p>
            When life changes, so should your TV. Flex your pack every month.
          </p>
          <p>
            Now with the Sky channels from NOW TV. With award-winning shows,
            hundreds of Box Sets, the best live sports in stunning 4K and the
            latest must-see movies. We really have it all.
          </p>
        </div>
        <div className="column">
          <img src="images/marketing/BT_under_cover.jpeg" alt="" />
          <h3>Mobile</h3>
          <p>
            <strong>5G with BT mobile is here.</strong>
          </p>
          <p>
            It gives you a faster and more reliable connection than ever before,
            even when you’re in the busiest places.
          </p>
          <p>
            It’s available in 50 cities and towns across the UK – and we are
            continuing to rollout in more places throughout 2020.
          </p>
        </div>
      </div>
      <div className="row info-table">
        <div className="table-column">
          <img src="images/marketing/BT_headset.png" alt="" />
          <p>
            You’ll always speak to one of our team based in the UK & Ireland
            when you call us
          </p>
        </div>
        <div className="table-column">
          <img src="images/marketing/BT_tools.png" alt="" />
          <p>Fast repair and 2 hr appointments slots, 7 days a week</p>
        </div>
        <div className="table-column">
          <img src="images/marketing/BT_customer_service.png" alt="" />
          <p>Expert help right to your doorstep with our Home Tech Experts</p>
        </div>
        <div className="table-column">
          <img src="images/marketing/BT_store_front.png" alt="" />
          <p>Get help in one of our 640 stores across the UK</p>
        </div>
      </div>
      <div className="marketing-button-container">
        <Button text="Continue" onClick={handleButtonClick} />
      </div>
    </div>
  </div>
)

MarketingBT.propTypes = {
  handleButtonClick: PropTypes.func.isRequired
}

export default MarketingBT
